import { Operator } from './types';
const getValue = (e) => {
    const { value } = e;
    if (e.valueGetter) {
        return e.valueGetter(value);
    }
    else if (typeof value === 'function') {
        return value(e);
    }
    else if (Array.isArray(value)) {
        return value.join(',');
    }
    else if (typeof value === 'string') {
        return `"${value}"`;
    }
    return value;
};
const createSerialiser = (operator) => (e) => `${e.field} ${operator} ${getValue(e)}`;
/**
 * Functions to to serialise an Expression to a string
 * @public
 */
export const Serialisers = {
    AND: (e) => createSerialiser(Operator.AND)(e),
    OR: (e) => createSerialiser(Operator.OR)(e),
    NOT: (e) => createSerialiser(Operator.NOT)(e),
    GT: (e) => createSerialiser(Operator.GT)(e),
    GE: (e) => createSerialiser(Operator.GE)(e),
    LT: (e) => createSerialiser(Operator.LT)(e),
    LE: (e) => createSerialiser(Operator.LE)(e),
    NE: (e) => createSerialiser(Operator.NE)(e),
    EQ: (e) => createSerialiser(Operator.EQ)(e),
    equals: (e) => `${e.field}.equals(${getValue(e)})`,
    equalsIgnoreCase: (e) => `${e.field}.equalsIgnoreCase(${getValue(e)})`,
    contains: (e) => `Expr.contains(${e.field}, ${getValue(e)})`,
    fieldContains: (e) => `${e.field}.contains(${getValue(e)})`,
    containsIgnoreCase: (e) => `Expr.containsIgnoreCase(${e.field}, ${getValue(e)})`,
    dateIsEqual: (e) => `Expr.dateIsEqual(${e.field}, ${getValue(e)})`,
    dateIsGreaterEqual: (e) => `Expr.dateIsGreaterEqual(${e.field}, ${getValue(e)})`,
    dateIsLessEqual: (e) => `Expr.dateIsLessEqual(${e.field}, ${getValue(e)})`,
};
